import axios from 'axios'
import { BASE_URL } from '@/constants'

const baseUrl = BASE_URL
const baseApiUrl = BASE_URL + '/api'

function showMaintenance() {
    alert('Server is under maintenance. Please retry later. Sorry for the inconvenience! \n系统维护中，请稍后再试。如有不便请见谅！')
}

function showUpgrade() {
    alert('Please upgrade App version! \n请升级应用版本！')
}

function apiRequest(opt) {
    // Cordova cannot set headers in mobile app
    // let token = authRequired ? localStorage.getItem('user_token') : ''
    const options = {
        method: opt.method || 'get',
        url: opt.url,
        headers: {
            // Authorization: token
        }
    }
    if (options.method === 'get') {
        options.params = opt.params || {}
    } else if (options.method === 'post' || options.method === 'put' || options.method === 'delete') {
        options.data = opt.params || {}
    }
    return axios(options).then(res => {
        if (res.hasOwnProperty('data') && res.data.hasOwnProperty('maintenance') && res.data['maintenance'] === true) {
            showMaintenance()
            throw Error('Server is under maintenance!')
        } else if (res.hasOwnProperty('data') && res.data.hasOwnProperty('upgrade') && res.data['upgrade'] === true) {
            showUpgrade()
            throw Error('Please upgrade App version!')
        }
        return res
    }).catch(error => {
        console.log(error)
        if (error.response.status === 503) {
            showMaintenance()
        } else {
            throw error
        }
    })
}

export function getBaseUrl() {
    return BASE_URL
}

export function getBaseApiUrl() {
    return baseApiUrl
}

export function getVideo(videoId, videoSrc = 'youtube') {
    return apiRequest({
        url: `${baseApiUrl}/v1/video/${videoSrc}/${videoId}`
    })
}

export function postMsg(content, token) {
    return apiRequest({
        url: `${baseApiUrl}/v1/message/post`,
        method: 'post',
        params: {
            'content': content,
            'token': token
        }
    })
}

export function getMsg(limit, msgId) {
    return apiRequest({
        url: `${baseApiUrl}/v1/message/all`,
        method: 'post',
        params: {
            'limit': limit,
            'msg_id': msgId
        }
    })
}

export function deleteMsg(msgId) {
    return apiRequest({
        url: `${baseApiUrl}/v1/message/delete`,
        method: 'post',
        params: {
            'msg_id': msgId
        }
    })
}

export function checkRemoteVideoSource(videoId, videoSrc = 'youtube') {
    let p = {
        'remote': 'true'
    }
    return apiRequest({
        url: `${baseApiUrl}/v1/video/${videoSrc}/${videoId}`,
        params: p
    })
}

export function shareVideo(videoId, token, category, label, videoSrc = 'youtube') {
    return apiRequest({
        url: `${baseApiUrl}/v1/video/${videoSrc}/${videoId}`,
        method: 'put',
        params: {
            'id': videoId,
            'source': videoSrc,
            'category': category,
            'label': label,
            'token': token
        }
    })
}

export function donateToVideo(videoId, amount, token, videoSrc = 'youtube') {
    return apiRequest({
        url: `${baseApiUrl}/v1/video/${videoSrc}/${videoId}`,
        method: 'post',
        params: {
            'id': videoId,
            'source': videoSrc,
            'amount': amount,
            'token': token
        }
    })
}

export function getVideoList(searchCategory, searchLabel, page, limit) {
    let p = {
        'page': page,
        'limit': limit
    }
    if (searchLabel) {
        p['label'] = searchLabel
        p['category'] = searchCategory
    }
    return apiRequest({
        url: `${baseApiUrl}/v1/video/list`,
        params: p
    })
}

export function searchVideoList(searchKeyWords, page, limit) {
    return apiRequest({
        url: `${baseApiUrl}/v1/video/search`,
        method: 'post',
        params: {
            'key_words': searchKeyWords,
            'page': page,
            'limit': limit
        }
    }, true)
}

export function getUserInfo() {
    let token = localStorage.getItem('user_token')
    return apiRequest({
        url: `${baseApiUrl}/v1/account/${token}`
    }, true)
}

export function getDailyReward(ap) {
    let token = localStorage.getItem('user_token')
    return apiRequest({
        url: `${baseApiUrl}/v1/account/daily_reward/${token}`,
        method: 'post',
        params: {
            'token': token,
            'ap': ap
        }
    }, true)
}

export function facebookUserLogin(oauthToken) {
    return apiRequest({
        url: `${baseUrl}/oauth/facebook/auth`,
        params: {
            'json': true,
            'oauth_token': oauthToken
        }
    }, true)
}

export function lineUserLogin(oauthToken) {
    return apiRequest({
        url: `${baseUrl}/oauth/line/auth`,
        params: {
            'json': true,
            'oauth_token': oauthToken
        }
    }, true)
}

export function wechatUserLogin(oauthToken) {
    return apiRequest({
        url: `${baseUrl}/oauth/wechat/auth`,
        params: {
            'json': true,
            'oauth_token': oauthToken
        }
    }, true)
}

export function updateSubtitle(videoId, content) {
    let token = localStorage.getItem('user_token')
    return apiRequest({
        url: `${baseApiUrl}/v1/subtitle/${videoId}`,
        method: 'put',
        params: {
            'content': JSON.stringify(content),
            'token': token
        }
    }, true)
}

export function getSubtitle(videoId) {
    return apiRequest({
        url: `${baseApiUrl}/v1/subtitle/${videoId}`
    })
}

export function getRedirectUrl(url) {
    return apiRequest({
        url: url
    })
}

export function getPoster() {
    return apiRequest({
        url: `${baseApiUrl}/v1/event/poster`
    })
}

export function getCountry() {
    return apiRequest({
        url: `https://ipapi.co/country/`
    })
}

export function getCategory() {
    return apiRequest({
        url: `${baseApiUrl}/v1/category/all`
    })
}



// WEBPACK FOOTER //
// ./src/utils/api.js